<template>
    <form method="post" autocomplete="off" enctype="multipart/form-data" @submit.prevent="uploadDocuments">
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <h4 class="text-center mb-4">UPLOAD DOCUMENTS</h4>
                <div class="subtitle with-border">Please Select SPEQ Customer Type</div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="row">
                    <div class="col-md-6">
                        <template v-for="cusType in customerTypes.slice(0, 5)" :key="cusType.value">
                            <div class="custom-control custom-radio pb-2">
                                <input
                                    name="customer_type"
                                    class="custom-control-input"
                                    :value="cusType.text"
                                    :id="'customer-type-' + cusType.value"
                                    type="radio"
                                    v-model="form.customer_type"
                                    :class="{
                                        'is-invalid': submitted && v$.form.customer_type.$error,
                                    }"
                                />
                                <label class="custom-control-label cursor-pointer color-333333" :for="'customer-type-' + cusType.value" >{{ cusType.text }}</label>
                            </div>
                        </template>
                    </div>
                    <div class="col-md-6">
                        <template v-for="cusType in customerTypes.slice(5)" :key="cusType.value">
                            <div class="custom-control custom-radio pb-2">
                                <input
                                    name="customer_type"
                                    class="custom-control-input"
                                    :value="cusType.text"
                                    :id="'customer-type-' + cusType.value"
                                    type="radio"
                                    v-model="form.customer_type"
                                    :class="{
                                        'is-invalid': submitted && v$.form.customer_type.$error,
                                    }"
                                />
                                <label class="custom-control-label cursor-pointer color-333333" :for="'customer-type-' + cusType.value" >{{ cusType.text }}</label>
                            </div>
                            <input
                                v-if="cusType.value == 8"
                                type="text"
                                v-model="form.other_specify"
                                id="other_specify"
                                name="other_specify"
                                class="form-control"
                                :class="{
                                    'is-invalid': submitted && cusType.value == 8 && v$.form.other_specify.$error,
                                }"
                            />
                            <span class="text-danger" v-if="cusType.value == 8 && v$.form.other_specify.$errors">
                                {{ v$.form.other_specify.$errors[0]?.$message }}
                            </span>
                        </template>
                    </div>

                    <span class="text-danger" v-if="v$.form.customer_type.$errors">
                        {{ v$.form.customer_type.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row pt-2 pb-2">
            <div class="col-sm-12 col-md-12 text-center">
                <div class="subtitle">Picture of Customer's credentials (<a href="/speq/valid-documents" target="_blank">what is this?</a>)</div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="last_name">
                        <div class="">
                            <span class="font-weight-bold">Select File</span>
                            <span class="color-333333 text-xs">
                                {{ '(PNG, JPG, or PDF; < 1MB in size)' }}
                            </span>
                        </div>
                    </label>
                    <div
                        class="dropzone-container"
                        @dragover="dragover"
                        @dragleave="dragleave"
                        @drop="drop"
                        >
                        <input
                            type="file"
                            multiple
                            name="file"
                            id="fileInput"
                            class="hidden-input"
                            @change="onChange"
                            ref="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                        />

                        <label for="fileInput" class="file-label">
                            <div v-if="isDragging">Release to drop files here.</div>
                            <div v-else>Drop files here or <u>click here</u> to upload.</div>
                        </label>
                        <div class="preview-container mt-4" v-if="form.files.length">
                            <div v-for="file in form.files" :key="file.name" class="preview-card">
                                <div>
                                    <img v-if="file.type == 'application/pdf'" class="preview-img" src="/images/pdf.png" />
                                    <img v-else class="preview-img" :src="generateURL(file)" />
                                    <span class="name">{{ file.name }}</span>
                                </div>
                                <div>
                                    <span class="ml-3" @click="remove(form.files.indexOf(file))">
                                        <b><i class="fa fa-times" aria-hidden="true"></i></b>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <span class="text-danger" v-if="v$.form.files.$errors">
                        {{ v$.form.files.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <button type="submit" class="mt-5 btn btn-outline-danger text-danger text-uppercase float-right">Submit</button>
    </form>
</template>

<script>
import {computed} from 'vue';
import { useStore } from "vuex"
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
    helpers
} from "@vuelidate/validators";

const { withMessage } = helpers;

export default {
    props: ['modalData','locationData'],
	emits: ['closeModal','updateOrders'],
	components: {
	},
    setup(){
		const store = useStore();

        function addMaterial(form) {
            store.dispatch("material/addMaterial", form);
        }

        function updateMaterial(form) {
            store.dispatch("material/updateMaterial", form);
        }

        function getNewSpeqOrders(currentLocation) {
            store.dispatch("getAllOrders", { 
                location_id: currentLocation.id,
                is_speq: 1, //SPEQ ORDERS
                order_type_id: 38,
                open_serial: true
            });
        }

		return {
            addMaterial,
            updateMaterial,
            getNewSpeqOrders
		}
	},
	data() {
		return {
            v$: useVuelidate(),
            form: {
                customer_type: null,
                other_specify: '',
                files: [],
            },
            isDragging: false,
            customerTypes: [
                { value: 1, text: 'Law Enforcement'},
                { value: 2, text: 'Military'},
                { value: 3, text: 'Federal Flight Deck Officer'},
                { value: 4, text: 'Fire Rescue'},
                { value: 5, text: 'EMT'},
                { value: 6, text: 'First Responder'},
                { value: 7, text: 'Private Security'},
                { value: 8, text: 'Other'},
            ],
            other: '',
            submitted: false,
            locationId: null
		}
	},
    validations() {
        return {
            form: {
                customer_type: {
                    required: withMessage('Customer Type is required', required),
                },
                other_specify: {
                    required: requiredIf(function () {
                        return this.form.customer_type == 'Other';
                    }),
                },
                files: {
                    required: withMessage('Credentials are required', required),
                }
            },
        };
    },
    mounted() {
        this.clearFields();
    },
    watch: {
        locationData(newval, oldval) {
            console.log(newval, oldval)
        },
    },
	methods: {
        onChange(e) {
            for ( let i = 0 ; i < this.$refs.file.files.length ; i++ ) {
                this.form.files.push(this.$refs.file.files[i]);
            }
            console.log('this.form.files', this.form.files)
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            console.log('this.$refs.file.files', this.$refs.file.files)
            this.onChange();
            this.isDragging = false;
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
        remove(i) {
            this.form.files.splice(i, 1);
        },
		uploadDocuments() {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // if ANY fail validation

                window.emitter.emit("changeLoaderStatus", true);

                if (this.form.files.length > 0) {
                    this.form.files.forEach((data, index) => {
                        const formData = new FormData();
                        formData.append('order_id', this.modalData.id);
                        formData.append('attachments', data);
                        formData.append('customer_type', this.form.customer_type);
                        formData.append('other_specify', this.form.other_specify);

                        axios
                            .post("/api/speq-upload-documents", formData)
                            .then((response) => {
                                this.getNewSpeqOrders(this.locationData)
                                window.emitter.emit("changeLoaderStatus", false);
                            });
                    });
                }

                this.$emit('closeModal')

            } else {
                // alert('Form failed validation')
            }
		},
        clearFields() {
            this.form.customer_type = '';
            this.form.files = [];
        }
	}
}
</script>
